import { isEmpty, some } from 'lodash-es';
import moment from 'moment/moment';

function LengthValidator(min, max, errorMessage) {
    return {
        validate: (value) => {
            let _value = value;
            _value = _value || '';
            if (_value == '') {
                return true;
            }
            if (min && max) {
                return min <= _value.length && _value.length <= max;
            }
            if (min) {
                return min <= _value.length;
            }
            if (max) {
                return _value.length <= max;
            }
            return true;
        },
        errorMessage: errorMessage ||
            (min && max
                ? `You must enter between ${min} and ${max} characters`
                : min
                    ? `You must enter at least ${min} characters`
                    : max
                        ? `You must enter less than ${max} characters`
                        : ''),
    };
}

const defaultValidator = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    validate(_x) {
        return true;
    },
};
const defaultDateRangeValidator = {
    validate(startDateMoment, endDateMoment) {
        const isEndBeforeStart = endDateMoment?.isBefore(startDateMoment);
        // check for if both dates valid dates, in the right order
        return (startDateMoment?.isValid() &&
            endDateMoment?.isValid() &&
            !isEndBeforeStart);
    },
};
const defaultDateInputValidator = {
    validate(value, dateFormat) {
        const date = moment(value, dateFormat, true);
        return date.isValid();
    },
    format(value, dateFormat) {
        return moment(value, dateFormat).format(dateFormat);
    },
};
function combineValidators(v1, v2) {
    const combined = {
        validate(x, y) {
            const res1 = y ? v1.validate(x, y) : v1.validate(x);
            const res2 = y ? v2.validate(x, y) : v2.validate(x);
            if (!res1) {
                combined.errorMessage = v1.errorMessage;
            }
            else if (!res2) {
                combined.errorMessage = v2.errorMessage;
            }
            return res1 && res2;
        },
    };
    return combined;
}
var BxfValidatorsNameEnum;
(function (BxfValidatorsNameEnum) {
    BxfValidatorsNameEnum["REQUIRED"] = "required";
    BxfValidatorsNameEnum["LENGTH"] = "length";
})(BxfValidatorsNameEnum || (BxfValidatorsNameEnum = {}));

function RequiredValidator(errorMessage) {
    return {
        validate: (value) => {
            if (typeof value === 'boolean') {
                return value;
            }
            return !isEmpty(value);
        },
        errorMessage: errorMessage || 'Error Message',
    };
}
function isRequiredValidator(validator) {
    return some(validator, ['name', BxfValidatorsNameEnum.REQUIRED]);
}

function validatorFactory(name, options, errorMessage) {
    const _options = options || {};
    switch (name) {
        case BxfValidatorsNameEnum.REQUIRED:
            return RequiredValidator(errorMessage);
        case BxfValidatorsNameEnum.LENGTH:
            return LengthValidator(_options.min, _options.max, errorMessage);
        default:
            return defaultValidator;
    }
}
function getValidator(list) {
    return (list || [])
        .map((v) => {
        let _v = v;
        if (_v && _v.name) {
            _v = _v;
            return validatorFactory(_v.name, _v.options, _v.errorMessage);
        }
        return _v;
    })
        .reduce(combineValidators, defaultValidator);
}

export { BxfValidatorsNameEnum as B, LengthValidator as L, RequiredValidator as R, defaultDateRangeValidator as a, defaultDateInputValidator as b, combineValidators as c, defaultValidator as d, getValidator as g, isRequiredValidator as i, validatorFactory as v };
